import { Component, Input } from '@angular/core';

import { LatestUpdate } from '@cigna/chcp/dashboard/data-access';

@Component({
  selector: 'cigna-latest-updates-tile',
  templateUrl: './latest-updates-tile.component.html',
  styleUrls: ['./latest-updates-tile.component.scss', '../tile.scss'],
})
export class LatestUpdatesTileComponent {
  @Input() shouldShowNewFeatures = false;

  @Input() updates: LatestUpdate[] = [];
  @Input() features: LatestUpdate[] = [];
  @Input() isLoading = false;

  isExpanded = false;
  defaultLength = 3;

  showMore() {
    this.isExpanded = true;
  }
}
